<template>
    <div>
        <div class="filter-wrap">
            <div class="filter-content">

                <div class="filter-item-wrap">
                    <div class="filter-item-title">
                        <p :style="{backgroundImage: `url('../../images/icn-filter-04.svg')`}">경기타입</p>
                    </div>
                    <div class="filter-item-content">
                        <div class="width-scroll">
                            <div class="filter-item" :class="selectType.code === '' ? 'select' : ''"
                                 @click="changeListType({code: '', name:'전체'})">전체
                            </div>
                            <div class="filter-item" :class="selectType.code === type.code ? 'select' : ''"
                                 v-if="type.code"
                                 v-for="(type) in typeList" @click="changeListType(type)">{{type.name}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-item-wrap">
                    <div class="filter-item-title">
                        <p :style="{backgroundImage: `url('../../images/icn-filter-08.svg')`}">세부종목</p>
                    </div>
                    <div class="filter-item-content">
                        <div class="width-scroll">
                            <div class="filter-item" :class="selectEvent.code === '' ? 'select' : ''"
                                 @click="changeListEvent({code: '', name:'전체'})">전체
                            </div>
                            <div class="filter-item" :class="selectEvent.code === event.code ? 'select' : ''"
                                 v-if="event.code"
                                 v-for="(event) in eventList" @click="changeListEvent(event)">{{event.name}}
                            </div>

                        </div>
                    </div>
                </div>

                <div class="filter-item-wrap">
                    <div class="filter-item-title">
                        <p :style="{backgroundImage: `url('../../images/icn-filter-09.svg')`}">연령</p>
                    </div>
                    <div class="filter-item-content">
                        <div class="width-scroll">
                            <div class="filter-item" :class="selectAge.code === '' ? 'select' : ''"
                                 @click="changeListAge({code: '', name:'전체'})">전체
                            </div>
                            <div class="filter-item" v-for="(age) in ageList"
                                 :class="selectAge.ageCode === age.ageCode ? 'select' : ''" @click="changeListAge(age)">
                                {{age.ageCode}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-item-wrap">
                    <div class="filter-item-title">
                        <p :style="{backgroundImage: `url('../../images/icn-filter-05.svg')`}">구분</p>
                    </div>
                    <div class="filter-item-content">
                        <div class="width-scroll">
                            <div class="filter-item" :class="selectLevel.code === '' ? 'select' : ''"
                                 @click="selectLEvel = {code: '', name:'전체'}">전체
                            </div>
                            <div class="filter-item" v-for="(level) in levelList"
                                 :class="selectLevel.levelCode === level.levelCode ? 'select' : ''" v-if="level.levelCode"
                                 @click="selectLevel = level">{{level.levelCode}}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="filter-bottom-wrap">
                <div class="filter-bottom-content">
                    <div class="close fl" @click="$emit('close')">닫기</div>
                    <div class="setting fr" @click="filterSetting">설정하기</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tnmtId: this.$route.params.tnmtId,
                typeList: null,
                eventList: null,
                ageList: null,
                levelList: null,
                levels: null,

                selectType: {code: '', name: '전체'},
                selectEvent: {code: '', name: '전체'},
                selectAge: {ageCode: '', name: '전체'},
                selectLevel: {levelCode: '', name: '전체'}

            }
        },
        mounted() {

            const type = this.$route.query.type
            const event = this.$route.query.event
            const age = this.$route.query.age
            const level = this.$route.query.level

            const _this = this

            //경기타입
            const typeTemp = {
                "tnmtId": this.tnmtId
            }
            this.$store.dispatch('filters/getListType', typeTemp).then(res => {
                _this.typeList = res.typeList
                if (type) {

                    _this.typeList.filter(item => {
                        if (item.code === type) {
                            _this.selectType = item
                        }
                    })

                }
            }).catch(err => {
                console.dir(err)
            })

            // 세부종목
            if (type) {
                const eventTemp = {
                    "tnmtId": this.tnmtId,
                    "typeCode": type
                }
                this.$store.dispatch('filters/getListEvent', eventTemp).then(res => {
                    _this.eventList = res.eventList
                    if (event) {
                        _this.eventList.filter(item => {
                            if (item.code === event) {
                                _this.selectEvent = item
                            }
                        })
                    }
                }).catch(err => {
                    console.dir(err)
                })
            }

            //연령
            if (event) {

                const eventTemp = {
                    "tnmtId": this.tnmtId,
                    "typeCode": type,
                    eventCode: event
                }

                this.$store.dispatch('filters/getListAge', eventTemp).then(res => {
                    _this.ageList = res.ageList
                    if (age) {
                        _this.ageList.filter(item => {
                            if (item.ageCode === age) {
                                _this.selectAge = item
                            }
                        })
                    }
                }).catch(err => {
                    console.dir(err)
                })
            }

            //구분
            if (age) {
                const levelTemp = {
                    "tnmtId": this.tnmtId,
                    "typeCode": type,
                    eventCode: event,
                    ageCode: age
                }

                this.$store.dispatch('filters/getListLevel', levelTemp).then(res => {
                    _this.levelList = res.levelList
                    if (level) {
                        _this.levelList.filter(item => {
                            if (item.levelCode) {
                                _this.selectLevel = item
                            }
                        })
                    }

                }).catch(err => {
                    console.dir(err)
                })
            }

        },
        methods: {
            getTypeList() {

                const _this = this
                const temp = {
                    "tnmtId": this.tnmtId
                }
                this.$store.dispatch('filters/getListType', temp).then(res => {
                    _this.typeList = res.typeList
                }).catch(err => {
                    console.dir(err)
                })
            },
            getEventList(type) {

                const _this = this
                const temp = {
                    "tnmtId": this.tnmtId,
                    "typeCode": type
                }
                this.$store.dispatch('filters/getListEvent', temp).then(res => {
                    _this.eventList = res.eventList
                }).catch(err => {
                    console.dir(err)
                })
            },
            changeListType(type) {
                this.selectType = type

                if (type.code === '') {
                    this.eventList = null
                    this.ageList = null
                    this.levelList = null
                } else {
                    this.getEventList(type.code)
                }

            },
            changeListEvent(event) {
                this.selectEvent = event

                const _this = this
                if (event.code === '') {
                    this.ageList = null
                    this.levelList = null
                } else {
                    const temp = {
                        "tnmtId": this.tnmtId,
                        "typeCode": this.selectType.code,
                        eventCode: event.code
                    }

                    this.$store.dispatch('filters/getListAge', temp).then(res => {
                        _this.ageList = res.ageList
                    }).catch(err => {
                        console.dir(err)
                    })
                }
            },
            changeListAge(age) {

                this.selectAge = age
                // console.dir('age => age')
                // console.dir(age)

                if (age.code === '') {
                    this.levelList = null
                } else {
                    const _this = this
                    const temp = {
                        tnmtId: this.tnmtId,
                        typeCode: this.selectType.code,
                        eventCode: this.selectEvent.code,
                        ageCode: age.ageCode
                    }

                    this.$store.dispatch('filters/getListLevel', temp).then(res => {
                        _this.levelList = res.levelList



                    }).catch(err => {
                        console.dir(err)
                    })
                }
            },
            filterSetting() {
                if(this.$route.fullPath === `${this.$route.path}?type=${this.selectType.code}&event=${this.selectEvent.code}&age=${this.selectAge.ageCode}&level=${this.selectLevel.levelCode}`){
                    this.$router.go()
                }else{
                    this.$router.replace(`?type=${this.selectType.code}&event=${this.selectEvent.code}&age=${this.selectAge.ageCode}&level=${this.selectLevel.levelCode}`)

                }
            }
        }
    }
</script>
